import React from 'react'
import styles from './Home.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import soflex from '../Images/Soflex.png'
import { Link } from "react-router-dom";

const Home = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <Link to="/home" className={styles.homeTitle}>
                        <FaHome size={22} className={styles.logo} />
                        <div className={styles.text}>Home</div>
                    </Link>
                    <Link to="/admanager" className={styles.manager}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad manager</div>
                    </Link>
                    <Link to="/billing" className={styles.manager}>
                        <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                        <div className={styles.text}>Billing</div>
                    </Link>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.soflex}><img src={soflex} alt="" /></div>
                        <div className={styles.details}>
                            <div className={styles.heading}>Business details</div>
                            <div className={styles.detail}>
                                <input type="text" placeholder='First name' className={styles.first} />
                                <div className={styles.name}>jack</div>
                                <input type="text" placeholder='Last name' style={{ marginTop: "6px" }} className={styles.first} />
                                <div className={styles.name}>Mapster</div>
                                <input type="text" placeholder='Company name and address' style={{ marginTop: "21px" }} className={styles.first} />
                                <div className={styles.addressArea}>
                                    <div className={styles.name} style={{ marginTop: "10px" }}>The Lazy Company</div>
                                    <div className={styles.address} style={{ marginTop: "10px" }}>Lazy Street 4 <br /> 7485 YT London <br /> United Kingdom</div>
                                </div>
                                <input type="text" placeholder='Tax info' style={{ marginTop: "10px" }} className={styles.first} />
                                <div className={styles.name} style={{ marginTop: "7px" }}>12345678</div>
                                <div className={styles.name} style={{ marginTop: "14px" }}>VAT 12345667</div>
                            </div>
                            <div className={styles.edit}>Edit</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home
